import type * as React from 'react';
import { cn } from '../lib/cn.ts';

export interface PageHeaderProps {
  title: string;
  description?: string;
  /** Action buttons — placed right-aligned. */
  actions?: React.ReactNode;
  /** Optional label above the title (mono eyebrow text). */
  eyebrow?: string;
  className?: string;
  'data-testid'?: string;
}

function PageHeader({
  title,
  description,
  actions,
  eyebrow,
  className,
  'data-testid': testId,
}: PageHeaderProps) {
  return (
    <div
      data-testid={testId ?? 'page-header'}
      className={cn('flex items-start justify-between gap-4', 'pb-6', className)}
    >
      <div className="flex flex-col gap-1">
        {eyebrow && (
          <p className="font-[var(--font-mono)] text-[10px] font-medium uppercase tracking-widest text-[var(--color-stone-mid)]">
            {eyebrow}
          </p>
        )}
        <h1 className="font-[var(--font-display)] text-2xl font-medium leading-tight tracking-tight text-[var(--color-charcoal)]">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-[var(--color-stone-mid)] leading-relaxed max-w-prose">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0 pt-0.5">{actions}</div>}
    </div>
  );
}

export { PageHeader };
